export enum ManeuverAction {
  DOCKING = 1,
  UNDOCKING = 2,
}
